import { fetchWithCorpId } from './api';

// Contacts live in one table since vms-backend#148 and are always reached
// through their owner, so the owner type comes from the URL rather than the
// payload. Owner is one of: clients, corps, vendors, employees.

export const CONTACT_OWNERS = {
  CLIENT: 'clients',
  CORP: 'corps',
  VENDOR: 'vendors',
  EMPLOYEE: 'employees',
};

// These exact values drive invoice email routing in the backend
// (InvoiceEmailRecipients): Billing receives the invoice, Billing_cc is
// copied, Billing_bcc gets a silent copy. Changing them breaks delivery.
export const CONTACT_ROLES = [
  { value: '', label: 'General (does not receive invoices)' },
  { value: 'Billing', label: 'Billing (receives invoices)' },
  { value: 'Billing_cc', label: 'Billing CC (copied on invoices)' },
  { value: 'Billing_bcc', label: 'Billing BCC (silent copy of invoices)' },
];

export const EMPTY_CONTACT = {
  name: '', firstName: '', middleName: '', lastName: '',
  phone1: '', phone2: '', email1: '', email2: '',
  addressLine1: '', addressLine2: '', city: '', state: '', zip: '', country: '',
  role: '', status: '', primary: false,
};

export const listContacts = (owner, ownerId) =>
  fetchWithCorpId(`/${owner}/${ownerId}/contacts`);

/**
 * Saves a whole panel of contacts for one owner: creates the new ones, updates
 * the ones that changed, deletes the ones removed. Contacts are only editable
 * once their owner exists, so every call needs a saved ownerId.
 */
export const saveContacts = async (owner, ownerId, contacts, original = []) => {
  const current = contacts || [];
  const before = original || [];

  const removed = before.filter(o => o.id && !current.some(c => c.id === o.id));
  await Promise.all(removed.map(c =>
    fetchWithCorpId(`/${owner}/${ownerId}/contacts/${c.id}`, { method: 'DELETE' })));

  for (const contact of current) {
    const body = JSON.stringify(contact);
    if (contact.id) {
      await fetchWithCorpId(`/${owner}/${ownerId}/contacts/${contact.id}`, { method: 'PUT', body });
    } else {
      await fetchWithCorpId(`/${owner}/${ownerId}/contacts`, { method: 'POST', body });
    }
  }
  return listContacts(owner, ownerId);
};

/** True when at least one contact can actually receive an invoice. */
export const hasBillingEmail = (contacts) => (contacts || []).some(
  c => 'Billing'.toLowerCase() === (c.role || '').toLowerCase()
    && c.email1 && c.email1.trim());
